import { atom } from "recoil";
import { recoilPersist } from 'recoil-persist';
import { User } from "../model/user";
import { EvWhereMember, IntegratedUser, UserExistsType } from "../model/userExists";
const { persistAtom } = recoilPersist();

export const errorState = atom({
  key: "error",
  default: "",
});

export const loadingState = atom({
  key: "loading",
  default: false,
});

export const loginState = atom({
  key: "login",
  default: false,
});

export const modalState = atom({
  key: "open",
  default: false,
});

export const alertState = atom({
  key: "alert",
  default: false,
});

export const isPopupOpenState = atom({
  key: "isPopupOpenState",
  default: false,
});

export const isRepayPopupOpenState = atom({
  key: "isRepayPopupOpenState",
  default: true,
});

export const isResendPopupOpenState = atom({
  key: "isResendPopupOpenState",
  default: false,
});

export const isResendConfirmOpenState = atom({
  key: "isResendConfirmOpenState",
  default: false,
});

export const isResendResultOpenState = atom({
  key: "isResendResultOpenState",
  default: false,
});

export const isRequestPopupOpenState = atom({
  key: "isRequestPopupOpenState",
  default: false,
});

export const isRequestConfirmOpenState = atom({
  key: "isRequestConfirmOpenState",
  default: false,
});

export const isRequestResultOpenState = atom({
  key: "isRequestResultOpenState",
  default: false,
});

export const resendUserCardNumberState = atom({
  key: "resendUserCardNumberState",
  default: "",
});

export const resendUserCardIDState = atom({
  key: "resendUserCardIDState",
  default: "",
});

export const resendReasonState = atom({
  key: "resendReasonState",
  default: "",
});

export const resendReasonDetailState = atom({
  key: "resendReasonDetailState",
  default: "",
});

export const resendLoadingState = atom({
  key: "resendLoadingState",
  default: false,
});

export const modalTypeState = atom({
  key: "modalType",
  default: "",
});

export const pageState = atom({
  key: "currentPage",
  default: 1,
});

export const searchState = atom({
  key: "search",
  default: "",
});

export const variableState = atom({
  key: "variable",
  default: undefined,
});
export const variableSecondState = atom({
  key: "variableSecond",
  default: undefined,
});

export const accessTokenState = atom<any>({
  key: "accessToken",
  default: undefined,
});

export const refreshTokenState = atom<any>({
  key: "refreshToken",
  default: undefined,
});
export const noticeDetailState = atom({
  key: "noticeDetail",
  default: undefined,
});

export const noticeMainState = atom({
  key: "noticeMain",
  default: undefined,
});

export const popUpState = atom({
  key: "popupState",
  default: undefined,
});

export const noticeState = atom({
  key: "notice",
  default: undefined,
});

export const findIdState = atom({
  key: "findId",
  default: undefined,
});

export const carCompanyState = atom({
  key: "carCompanyState",
  default: undefined,
});

export const carState = atom({
  key: "carState",
  default: undefined,
});

export const showUserState = atom({
  key: "showUserSate",
  default: undefined,
});

export const userInfoState = atom<User | undefined>({
  key: "userInfoState",
  default: undefined,
});

export const requestMemberCardState = atom({
  key: "requestMemberCardState",
  default: undefined,
});

export const chargingState = atom({
  key: "chargingState",
  default: undefined,
});

export const platformState = atom({
  key: "platformState",
  default: undefined,
});

export const certifyPhoneState = atom({
  key: "certifyPhoneState",
  default: undefined,
});

export const checkAuthState = atom({
  key: "checkAuthState",
  default: undefined,
});

export const userRegistState = atom({
  key: "userRegistState",
  default: undefined,
});

export const userIntegratedState = atom<IntegratedUser | undefined>({
  key: "userIntegratedState",
  default: undefined,
});

export const userExistsState = atom<UserExistsType | undefined>({
  key: "userExistsState",
  default: undefined,
});

export const requiredDataState = atom<any>({
  key: "requiredDataState",
  default: undefined,
});

export const evWhereMemberState = atom<EvWhereMember | undefined>({
  key: "evWhereMemberState",
  default: undefined,
});

export const isEvWhereMemberState = atom({
  key: "isEvWhereMemberState",
  default: false,
});

export const getEvWherePhoneState = atom({
  key: "getEvWherePhoneState",
  default: undefined,
});

export const companyUserRegistState = atom({
  key: "companyUserRegistState",
  default: undefined,
});

export const findPwState = atom({
  key: "findPwState",
  default: undefined,
});

export const smartroState = atom({
  key: "smartroState",
  default: undefined,
});

export const smartroRoamingState = atom({
  key: "smartroRoamingState",
  default: undefined,
});

export const qrTenantQueryState = atom({
  key: "qrTenantQueryState",
  default: undefined,
});

export const smartroTenantState = atom({
  key: "smartroTenantState",
  default: undefined,
});

export const userRegistIngState = atom({
  key: "userRegistIngState",
  default: undefined as any,
  effects_UNSTABLE: [persistAtom],
});

export const userSocialRegistState = atom({
  key: "userSocialRegistState",
  default: undefined as any,
})

export const smatroReigistBillingState = atom({
  key: "smatroReigistBillingState",
  default: undefined,
});

export const userChargingState = atom({
  key: "userChargingState",
  default: undefined
})

interface UserPoint {
  membership_card_number?: string;
}

export const userPointState = atom<UserPoint | undefined>({
  key: "userPointState",
  default: undefined,
});

export const userPointListState = atom({
  key: "userListPointState",
  default: undefined,
})

export const userExpiresState = atom({
  key: "userExpiresState",
  default: undefined,
})

export const userMembershipGrade = atom({
  key: "userMembershipGrade",
  default: undefined,
})

export const justMembershipGrade = atom({
  key: "justMembershipGrade",
  default: undefined,
})

export const userRepayState = atom({
  key: "userRepayState",
  default: undefined,
})

export const userPaidFailState = atom({
  key: "userPaidFailState",
  default: undefined,
})